import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { buttonHPadding } from '../common';
import { ButtonPropsSizeType } from '../common.type';

type ButtonTextProps = ComponentProps<'div'> & {
  size?: ButtonPropsSizeType;
};
export default function ButtonText({ size, className, ...props }: ButtonTextProps) {
  return (
    <span
      className={cn('self-center justify-center whitespace-nowrap grow flex', buttonHPadding(size), className)}
      {...props}
    />
  );
}
